import React from "react";
import Container from "./container";

function EvolucaoMigracao() {
  const evolucaoItems = [
    {
      id: 1,
      imgSrc: "../assets/evolucao1.png",
      alt: "Economizamos recursos",
      text: "Economizamos recursos",
    },
    {
      id: 2,
      imgSrc: "../assets/evolucao2.png",
      alt: "Otimizamos seu tempo",
      text: "Otimizamos seu tempo",
    },
    {
      id: 3,
      imgSrc: "../assets/evolucao3.png",
      alt: "Projetamos seu desempenho",
      text: "Projetamos seu desempenho",
    },
  ];

  return (
    <div
      className="w-full pb-20 lg:pt-[112px] flex flex-col items-center justify-center"
      style={{
        backgroundImage: "url('../assets/cover-proposito.png')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <Container>
        <div className="flex flex-col gap-4 items-center justify-center w-full lg:gap-0 lg:flex-row lg:justify-between">
          {evolucaoItems.map((item, index) => (
            <React.Fragment key={item.id}>
              <div className="flex flex-col items-center justify-center lg:w-1/3">
                <div className="mb-6 flex justify-center">
                  <img src={item.imgSrc} alt={item.alt} />
                </div>
                <p className="text-white text-center font-inter-regular text-xl">
                  {item.text}
                </p>
              </div>

              {index < evolucaoItems.length - 1 && (
                <div
                  className={`hidden lg:block h-32 w-[1px] bg-blue-400 ${index === 1 ? "-ml-12 mr-12" : "-mr-10"}`}
                />
              )}
            </React.Fragment>
          ))}
        </div>
      </Container>
    </div>
  );
}

export default EvolucaoMigracao;
